import { Component, Input, EventEmitter, Output } from '@angular/core';
import * as debug from 'debug';
import * as _ from 'lodash';
import * as turf from '@turf/turf';
import * as $ from 'jquery';
import { UserProvider } from '../../providers/user/user';
import { GeolocationProvider } from '../../providers/geolocation/geolocation';
import { PlaceServiceProvider } from '../../providers/trip-service/place-service';
import { GoogleProvider } from '../../providers/google/google';
import { TripService } from '../../providers/trip-service/trip-service';
import { ToolsProvider } from '../../providers/tools/tools';

@Component({
  selector: 'policy-footer',
  templateUrl: 'policy-footer.html',
})
export class PolicyFooterComponent {
  log = debug('app:PolicyFooterComponent');

  constructor(
    public userService: UserProvider,
    public geolocation: GeolocationProvider,
    public placesService: PlaceServiceProvider,
    public google: GoogleProvider,
    public tripService: TripService,
    public tools: ToolsProvider
  ) {}

  ngOnInit() {
  }
}



// WEBPACK FOOTER //
// ./src/components/policy-footer/policy-footer.ts